import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { ProductSubNav } from "@/components/portal/ProductSubNav";
import { automationSubNav } from "@/lib/navigationItems";
import { useAuth } from "@/contexts/AuthContext";

export const Route = createFileRoute("/portal/automation")({
  component: AutomationLayout,
});

function AutomationLayout() {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  const isPlatformAdmin = user?.is_admin === true;

  useEffect(() => {
    // Redirect non-platform-admins to portal home
    // Don't redirect while still loading auth state
    if (!isLoading && !isPlatformAdmin) {
      navigate({ to: "/portal" });
    }
  }, [isLoading, isPlatformAdmin, navigate]);

  // Show nothing while checking auth or if not authorized
  // This prevents flash of content before redirect
  if (isLoading || !isPlatformAdmin) {
    return null;
  }

  return (
    <div className="space-y-4">
      <ProductSubNav items={automationSubNav} />
      <Outlet />
    </div>
  );
}
